import React, { useState } from "react";
import { CardBody, Input } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import TextareaAutosize from "react-textarea-autosize";
import styles from "../../styles.scss";
import SectionLabel from "../../common/sectionLabel";
import classNames from "classnames";

const EmailFooterSection = () => {
  const [organizationName, setOrganizationName] = useState("Test Charity Mission");
  const [organizationAddress, setOrganizationAddress] = useState("123 Test Ave. 33021, Weston, Florida");

  return (
    <CardBody>
      <div className={styles.section}>
        <SectionLabel
          label="Organization Name"
          tooltip="Change the organization name that's reflected in your email's footer"
        />
        <Input
          type="text"
          value={organizationName}
          onChange={e => setOrganizationName(e.target.value)}
          className={styles.input}
        />
        <SectionLabel
          label="Organization Address"
          tooltip="Change the organization address that's reflected in your email's footer"
        />
        <TextareaAutosize
          className={classNames(styles.textarea, styles.mainMessage)}
          placeholder="Enter the main message for the banner"
          value={organizationAddress}
          onChange={e => setOrganizationAddress(e.target.value)}
          minRows={2}
          maxRows={6}
        />
      </div>
    </CardBody>
  );
};

export default withStyles(styles)(EmailFooterSection);
